<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items"/>
        <b-card>
          <div class="col-md-6">
            <h5 class="float-left"><span>Name: </span> <span style="color: #10948E">{{ ses.name }}</span> <span> - EP ID: </span><span style="color: #10948E">{{ ses.ep_id ? ses.ep_id.ep_id : 'Pending'}}</span></h5>
          </div>
          <div class="col-md-6 float-right">
            <b-button v-b-modal.rrc-modal type="button"
                      @click="$bvModal.show('rrc-modal'),resetForm()" class="btn btn-success float-right btn-sm mb-1">
              <i class="mdi mdi-plus-box-outline"></i> Add RRC
            </b-button>
          </div>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Deed No.</th>
                <th>Deed Date</th>
                <th>Mouza</th>
                <th>Upazila</th>
                <th>Sub Reg Office</th>
                <th>Land Type</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(rrc, index) in rrcs" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ rrc.deed_number }}</td>
                <td>{{ rrc.deed_date }}</td>
                <td>{{ rrc.mouza }}</td>
                <td>{{ rrc.upazila }}</td>
                <td>{{ rrc.sub_reg_office }}</td>
                <td>{{ rrc.land_type ? rrc.land_type.land_type_desc : ''}} </td>
                <td>
                  <a href="javascript:void(0);"
                     class="action-icon" title="Update RRC" @click="updateRrc(rrc.id)">
                    <i class="mdi mdi-square-edit-outline editButton"></i>
                  </a>
                  <a href="javascript:void(0);"
                     class="action-icon" title="Delete RRC" @click="onDelete(rrc.id, index)">
                    <i class="mdi mdi-delete deleteButton"></i>
                  </a>
                  <a href="javascript:void(0);"
                     class="action-icon" title="View RRC" @click="viewRrc(rrc)">
                    <i class="mdi mdi-account-card-details viewColor"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="loader" class="loader">Loading...</div>
            <h5 class="text-center text-secondary" v-if="rrcs.length === 0 || !flag">
              No Data Found
            </h5>
          </div>
        </b-card>
      </div>
    </div>
    <view-rrc-modal
        :rrc="rrc"
    ></view-rrc-modal>
    <rrc-modal
        @getSesRrc="getSesRrc"
        :rrc="rrc"
        :btn_edit="btn_edit"
        @resetForm="resetForm"
        ref="rrcModal"
    ></rrc-modal>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import viewRrcModal from './modal/viewRrcModal'
import rrcModal from './modal/rrcModal'

export default {
  page: {
    title: "List of RRC",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, viewRrcModal, rrcModal},
  data() {
    return {
      title: "List of RRC",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "List of RRC",
          active: true
        }
      ],
      rrcs: {},
      flag: false,
      loader: false,
      btn_edit: false,
      rrc: {},
      ses: {},
    };
  },

  mounted() {
    this.ses_id = this.$route.params.ses_id;
    this.getSesRrc();
  },
  methods: {
    getSesRrc() {
      let ses_id = this.$route.params.ses_id;
      this.flag = true
      this.loader = true
      http.get("api/rrc/search/" + ses_id).then(response => {
        if (!response.error) {
          this.flag = true;
          this.loader = false
          this.rrcs = response.data.rrcs;
          this.ses = response.data.ses;
        }
      });
    },
    onDelete(id, index) {
      if (confirm("Do you really want to delete?")) {
        http.delete("api/rrcs/" + id).then(response => {
          this.search();
          this.$bvToast.toast(response.data.message, {
            title: "Success",
            autoHideDelay: 5000,
            variant: "success"
          });
        });
      }
    },
    viewRrc(rrc){
      this.rrc = {};
      this.rrc = rrc;
      this.$root.$emit("bv::show::modal", "rrc-view-modal");
    },
    async updateRrc(rrc_id){
      this.rrc = {};
      this.btn_edit = true;
      await http.get("api/rrcs/" + rrc_id +  "/edit" ).then(response => {
        this.rrc = response.data.rrc;
        this.$root.$emit("bv::show::modal", "rrc-modal");
      });
    },
    resetForm() {
      this.btn_edit = false;
      this.rrc = {};
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    },
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
<style src="vue-select/dist/vue-select.css"></style>
